import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import UserAvatar from '../../../../../../User/Avatar';
import UserLink from '../../../../../../User/Link';
import { useOverlayContext } from '../../../Overlay/OverlayContext';
import s from './LargeAttribution.scss';
var LargeAttribution = function (_a) {
    var deviation = _a.deviation, className = _a.className;
    var showAuthorTooltip = useOverlayContext(deviation).showAuthorTooltip;
    var t = useTranslation().t;
    return (React.createElement("div", { className: classnames(s['attribution'], className) }, deviation.author && (React.createElement(React.Fragment, null,
        React.createElement(UserAvatar, { className: s['avatar'], size: 32, user: deviation.author, withTooltip: showAuthorTooltip, "aria-hidden": "true" }),
        React.createElement("div", { className: s['user-link-wrap'] },
            React.createElement("div", { className: s['by'] }, t('deviationview.overlay.by')),
            React.createElement(UserLink, { className: s['user-link'], user: deviation.author, withTooltip: showAuthorTooltip, biData: {
                    creatorid: deviation.author.useridUuid,
                } }))))));
};
LargeAttribution.displayName = 'LargeAttribution';
export default LargeAttribution;
//# sourceMappingURL=LargeAttribution.js.map